import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Asset } from 'globals/store/assets.data';
import { AssetCardComponent } from 'src/app/components/cards/asset-card.component';

@Component({
    selector: 'asset-link',
    template: `
<div class="top">
  <asset-card [tryToShowAsLink]="true" [asset]="asset"></asset-card>
  <ng-container *ngIf="!readOnly && !onlyLink">
    <span class="dot">•</span><span class="link" (click)="editAsset($event)">Edit</span>
  </ng-container>
</div>
<div class="bottom empty-text" *ngIf="!onlyLink">Modified by {{ asset.updatedBy }} at {{ asset.updatedAt | date: 'HH:mm on d MMMM y' }}</div>
`,
    styleUrls: ['./asset-link.scss'],
    standalone: true,
    imports: [CommonModule, AssetCardComponent],
})
export class AssetLinkComponent {
    @Input() asset: Asset
    @Input() readOnly = true
    @Input() onlyLink = false
    @Output() openAsset: EventEmitter<null> = new EventEmitter()

    editAsset(event) {
      event.stopPropagation()
      this.openAsset.emit()
    }

}



